import { Component, OnDestroy } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { debounceTime, of, switchMap, takeWhile } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { EntitiesService, IEntity, IEntityField, IFieldType } from '@app/core/entities';
import { EntityDialogComponent } from '../entity-dialog/entity-dialog.component';


@Component({
  selector: 'app-entity-detail',
  templateUrl: './entity-detail.component.html',
  styleUrls: ['./entity-detail.component.css']
})
export class EntityDetailComponent implements OnDestroy {

  public form: FormGroup;
  public formFields: FormGroup;

  public entity: IEntity;
  public fieldTypes: IFieldType[];

  private destroyed: boolean;

  constructor(
    private entityService: EntitiesService,
    private dialogService: DialogService,
    private route: ActivatedRoute
  ) {

    this.form = new FormGroup({
      title: new FormControl({ value: '', disabled: true}, [Validators.required]),
    });

    this.formFields = new FormGroup({
      fields: new FormArray([])
    });

    this.fieldTypes = this.entityService.getFieldTypes();
  }


  public get getFormFields() {
    return this.formFields.get('fields') as FormArray;
  }

  private saveChanges(): void {

    this.getFormFields.updateValueAndValidity();
    if (!this.getFormFields.valid) {
      return;
    }

    this.entity.fields = this.getFormFields.value;

    this.entityService.createUpdateEntity(this.entity)
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe((entity) => {
      this.getFormFields.patchValue(entity.fields, { emitEvent: false });
    });
  }

  public ngOnInit(): void {

    this.route.data.pipe(
      switchMap(data => of(data['entity'] as IEntity)),
      takeWhile(() => !this.destroyed)
    )
    .subscribe(entity => {

      this.entity = entity;
      this.form.patchValue(entity);

      entity.fields.forEach(field => {
        this.addField(field);
      });

      if (!entity.fields.length) {
        this.addField();
      }

    });

  }

  public addField(field?: IEntityField): void {

    this.getFormFields.updateValueAndValidity();
    if (!this.formFields.valid) {
      return;
    }

    const formGroup = new FormGroup({
      id: new FormControl(field?.id),
      entityId: new FormControl(this.entity.id),
      title: new FormControl(field?.title, Validators.required),
      fieldType: new FormControl(field?.fieldType, Validators.required),
    });

    this.getFormFields.controls.push(formGroup);

    formGroup.valueChanges.pipe(
      takeWhile(() => !this.destroyed),
      debounceTime(500)
    ).subscribe(() => this.saveChanges());

  }

  public deleteField(i: number): void {
    this.getFormFields.removeAt(i);
  }

  public editProperties(): void {

    this.dialogService.open(EntityDialogComponent, {
      header: 'Propiedades de la entidad',
      height: '600px',
      width: '800px',
      data: {
        entity: this.entity
      }
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(entity => {

      if (entity) {
        this.entity = entity;
        this.form.patchValue(entity);
      }

    })

  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

}
